import React from "react";
import { Route } from "react-router-dom";
// import { DomainView, CaseView } from "../layouts";
import Admin from "us.collection.admin";

import {
  MainSearch,
  UserRoleSettings,
  UserSettings,
  Home,
} from "./asyncRoutes";

export default () => {
  const MainViewModules = [Admin];
  return [
    <Route  
      key="search"
      path={"/search"}
      element={ <MainSearch />}
    />,
    <Route 
      key="/user-role-settings"
      path={"/user-role-settings"}
      element={ <UserRoleSettings />}
    />,
    <Route 
      key="/user-settings"
      path={"/user-settings"}
      element={ <UserSettings />}
    />,
    <Route   key="/" path={"/"} element={ <Home />} />,
    ...MainViewModules.map(({ Routes }) => Routes.asyncRoutes),
  ];
};
